import { render } from "./CustomHotelTravel.vue?vue&type=template&id=5dde1588&scoped=true"
import script from "./CustomHotelTravel.vue?vue&type=script&lang=js"
export * from "./CustomHotelTravel.vue?vue&type=script&lang=js"

import "./CustomHotelTravel.vue?vue&type=style&index=0&id=5dde1588&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dde1588"]])

export default __exports__